import { LimitBadgeProps } from "../types";

import { formatPrice } from "@/utils/utils";

export const LimitBadge = ({
  isOverLimit,
  limit,
  projectedPrice,
  isLoading,
  total,
}: LimitBadgeProps) => {
  if (isLoading) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-center gap-1.5 rounded-md bg-gray-100 px-2 py-1">
          <div className="h-2 w-2 animate-pulse rounded-full bg-gray-300" />
          <div className="h-3 w-16 animate-pulse rounded bg-gray-300" />
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      {!isOverLimit ? (
        <div className="flex items-center gap-1.5 rounded-md bg-gray-100 px-2 py-1">
          <div className="h-2 w-2 rounded-full bg-blue-500" />
          <div className="flex flex-col">
            <span className="text-xs font-medium leading-4 text-gray-600">
              <span className="tabular-nums">
                {typeof total === "number" ? total.toLocaleString() : total}
              </span>
              <span className="mx-1 text-gray-400">/</span>
              <span className="tabular-nums">
                {typeof limit === "number" ? limit.toLocaleString() : limit}
              </span>
            </span>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-1.5 rounded-md bg-red-100 px-2 py-1">
          <div className="h-2 w-2 rounded-full bg-red-500" />
          <div className="flex flex-col">
            <span className="text-xs font-medium leading-4 text-red-600">
              <span className="tabular-nums">
                {typeof total === "number" ? total.toLocaleString() : total}
              </span>
              <span className="mx-1 text-red-400">/</span>
              <span className="tabular-nums">
                {typeof limit === "number" ? limit.toLocaleString() : limit}
              </span>
            </span>
            <span className="text-xs font-medium leading-4 text-red-500">
              {projectedPrice > 0
                ? `Projected Price: ${formatPrice(projectedPrice)}`
                : "You are over limit"}
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
